import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OneStepLogoService {
	constructor(private http: HttpClient) {}

	getUrl(): Observable<string> {
		return this.http.get<string>(`api/one-step-logo/get`);
	}

	getUrlAsAdmin(hostUserId: string): Observable<string> {
		return this.http.get<string>(`api/one-step-logo/getAsAdmin?userId=${hostUserId}`);
	}

	uploadLogo(files: File[]): Observable<void> {
		const formData = new FormData();

		// Note: The files input control has been configured to only allow a single file to be
		// selected. However, it still returns an array of files.So we have to extract the file
		// from the array before we forward it for processing.
		for (const file of files) {
			formData.append('file', file, file.name);
		}

		return this.http.post<any>('api/one-step-logo/upload', formData);
	}

	uploadLogoAsAdmin(files: File[], hostUserId: string): Observable<void> {
		const formData = new FormData();

		// Note: The files input control has been configured to only allow a single file to be
		// selected. However, it still returns an array of files.So we have to extract the file
		// from the array before we forward it for processing.
		for (const file of files) {
			formData.append('file', file, file.name);
		}

		return this.http.post<any>(`api/one-step-logo/uploadAsAdmin?userId=${hostUserId}`, formData);
	}
}
